module.exports = __webpack_public_path__ + "57678dc2dc8bb03d0c04297eea38149a.png";